import React from "react";
import { createPortal } from "react-dom";
import { calcMenuPos } from "../constants";

const MORE_ACTIONS = [
  { key: "edit", label: "Edit candidate" },
  { key: "messages", label: "Messages" },
  { key: "activity", label: "Activity" },
  { key: "files", label: "Files" },
];

// View / Notes / "more" (three dots) buttons for a candidate row.
// onAction(key) receives "view", "notes", "edit", "messages", "activity" or "files".
const RowActionsCell = ({ isMenuOpen, menuPos, onOpenMenu, onCloseMenu, onAction, disabled }) => {
  const toggleMenu = (e) => {
    if (isMenuOpen) onCloseMenu();
    else onOpenMenu(calcMenuPos(e.currentTarget, { width: 160, height: 170, alignRight: true }));
  };

  return (
    <div className="action-btns-v2">
      <button className="action-btn-v2 view-btn" title="View candidate" disabled={disabled} onClick={() => onAction("view")}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z" />
          <circle cx="12" cy="12" r="3" />
        </svg>
      </button>
      {/* Messages-style icon that opens the Notes popup */}
      <button className="action-btn-v2 edit-btn" title="Notes" disabled={disabled} onClick={() => onAction("notes")}>
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
          <path d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2z" />
        </svg>
      </button>
      <div className="action-more-wrap">
        <button className="action-btn-v2" title="More actions" disabled={disabled} onClick={toggleMenu}>
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="5" r="1.6" fill="currentColor" />
            <circle cx="12" cy="12" r="1.6" fill="currentColor" />
            <circle cx="12" cy="19" r="1.6" fill="currentColor" />
          </svg>
        </button>
        {isMenuOpen && menuPos && createPortal(
          <div className="action-more-menu" style={{ position: "fixed", left: menuPos.left, top: menuPos.top, bottom: menuPos.bottom, zIndex: 9999 }}>
            {MORE_ACTIONS.map((a) => (
              <button key={a.key} className="action-more-item" onClick={() => { onCloseMenu(); onAction(a.key); }}>{a.label}</button>
            ))}
          </div>,
          document.body
        )}
      </div>
    </div>
  );
};

export default RowActionsCell;
